
import PostMessageHelper from '@/helpers/PostMessageHelper';
import Message from '@/models/MessageModel';
import AnswerButton from '@/components/App/AnswerButton/index.vue';
import NewMessage from '@/models/NewMessageModel';
import CalculaterButtonWidth from '@/helpers/CalculaterButtonWidth';
import TriggerMessageContentWrap from '@/components/TriggerPreview/TriggerMessageContentWrap.vue';
import Bubbles from './Bubbles.vue';
import Widget from '@/models/WidgetModel';

import { defineComponent, PropType } from 'vue';
import SelectChanelRefactor from '@/components/MessageTypes/SelectChanelRefactor/index.vue';

export default defineComponent({
	name: 'trigger-preview',

	components: {
		SelectChanelRefactor,
		AnswerButton,
		TriggerMessageContentWrap,
		Bubbles
	},

	props: {
		message: {
			type: Object as PropType<Message>,
			required: true
		},

		isShowAnswerField: {
			type: Boolean,
			required: true
		},

		widget: {
			type: Object as PropType<Widget>,
			required: true
		},

		respondentId: {
			type: Number,
			required: true
		}
	},

	setup() {
		return { CalculaterButtonWidth };
	},

	data() {
		return {
			text: '',
			// Собираем сюда сообщения в одну цепочку, если сообщение разделено таймаутами
			// Очищается оно само, как только закрывается превью
			messagesContent: [] as Array<Message>,
			// Метка если сообщение было последнее
			isLastMessage: false,
			heightContent: 0
		};
	},

	watch: {
		message() {
			this.fillMessagesContent();
			this.$nextTick(() => this.updateSizeIframe(true));
		}
	},
	computed: {
		// Если высота контента больше 120px показываем баблы
		isShowBubbles(): boolean {
			return this.heightContent >= 120;
		}
	},

	created() {
		this.fillMessagesContent();
		this.$nextTick(() => this.updateSizeIframe(true));
		if (this.widget.is_pulsar) {
			PostMessageHelper.postMessage({
				name: 'isPulsar',
				payload: {
					isPulsar: true
				}
			});
		}
	},

	methods: {
		// Обновляем высоту iframe
		updateSizeIframe(oneMore: boolean): void {
			this.$nextTick(() => {
				const preview = document.querySelector('#trigger-preview') as HTMLDivElement;
				const content = document.querySelector('#content') as HTMLDivElement;
				this.heightContent = content.clientHeight;
				if (!preview) {
					return;
				}

				PostMessageHelper.postMessage({
					name: 'changeHeight',
					payload: {
						height: preview.clientHeight + 16
					}
				});

				// Рекурсивно вызываем еще раз, чтобы подкорректировать
				if (oneMore) {
					setTimeout(() => {
						this.updateSizeIframe(false);
					}, 500);
				}
			});
		},

		closePreviewTrigger(): void {
			PostMessageHelper.postMessage({ name: 'closePreviewTrigger' });
		},

		sendMessage(payload: NewMessage): void {
			this.$emit('send-message', payload);
			// При нажатии на кнопку, отправку собщения мы открываем виджет
			this.openWidget();
		},

		inputValue(): void {
			this.sendMessage({ text: this.text });
			this.text = '';
		},

		openWidget(): void {
			PostMessageHelper.postMessage({ name: 'openWidget' });
			this.toggleTypingAnimation(false);
		},

		toggleMutVideo(): void {
			PostMessageHelper.postMessage({ name: 'toggleMutVideo' });
		},

		// Последовательно наполняем контент сообщения (таймауты)
		fillMessagesContent() {
			this.makeSound();
			// Если уже было последнее сообщение без таймаута то мы просто очищаем и начинаем по новой докидывать сообщения
			if (this.isLastMessage) {
				this.messagesContent = [];
			}

			this.messagesContent.push(this.message);

			const isBotTyping = !!this.message.delay as boolean;

			if (isBotTyping) {
				this.toggleTypingAnimation(true);
			} else {
				this.scheduleStopTypingAnimation(this.message);
			}
		},

		toggleTypingAnimation(isBotTyping: boolean): void {
			PostMessageHelper.postMessage({
				name: 'typing',
				payload: {
					isBotTyping
				}
			});
		},

		// Откладываем отключение анимации печатания
		// пока не до отобразим сообщение с контентом
		scheduleStopTypingAnimation(message: Message): void {
			// Задержка равно длительности анимации
			// в соседнем компоненте
			let delayOfStop = 500;

			if (message.video || message.image) {
				delayOfStop += 1000;
			}

			setTimeout(() => {
				this.toggleTypingAnimation(false);

				// Ставим метку, что это было последнее сообщение
				this.isLastMessage = true;
				this.$nextTick(() => this.updateSizeIframe(false));
			}, delayOfStop);
		},

		// Звук прихода нового сообщения
		makeSound(): void {
			PostMessageHelper.postMessage({
				name: 'makeSound',
				payload: {
					soundPath: this.widget.sound
				}
			});
		}
	}
});
